import { DotsThree, Eye, EyeSlash } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { ActionButton } from "@tokenterminal/ui/ActionButton/ActionButton"
import { Box } from "@tokenterminal/ui/Box"
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@tokenterminal/ui/ToggleGroup/ToggleGroup"
import { toggleGroupItemCss } from "@tokenterminal/ui/ToggleGroup/ToggleGroup.css"
import { useMemo } from "react"
import { type GranularityOption, type GranularityValues } from "./constants"

interface Props {
  onChange: (value: GranularityValues) => void
  selectedValue?: GranularityValues
  selectedPeriod?: boolean
  items: Array<GranularityOption>
  disabled?: boolean
  onPeriodChange?: (value: boolean) => void
  showPeriodSelector?: boolean
}

export function Selector({
  onChange,
  onPeriodChange,
  selectedValue,
  selectedPeriod,
  items,
  disabled: isDisabled,
  showPeriodSelector = true,
}: Props) {
  const actions = useMemo(() => {
    const availableActions = []

    if (selectedPeriod) {
      availableActions.push({
        label: (
          <div className="flex gap-2 items-center justify-between">
            <div>Hide current period</div>
            <Icon as={EyeSlash} />
          </div>
        ),
        onClick: () => onPeriodChange?.(false),
      })
    } else {
      availableActions.push({
        label: (
          <div className="flex gap-2 items-center justify-between">
            <div>Show current period</div>
            <Icon as={Eye} />
          </div>
        ),
        onClick: () => onPeriodChange?.(true),
      })
    }

    return (
      <ActionButton
        actions={availableActions}
        size="small"
        disabled={selectedValue === "day"}
        style={{
          height: "100%",
          width: "auto",
          aspectRatio: "1/1",
        }}
      >
        <Icon as={DotsThree} />
      </ActionButton>
    )
  }, [onPeriodChange, selectedPeriod, selectedValue])

  return (
    <ToggleGroup>
      {items.map(({ label, value, disabled }, index) => (
        <ToggleGroupItem
          key={index}
          isActive={selectedValue === value}
          onClick={() => {
            onChange(value)
          }}
          disabled={disabled || isDisabled}
        >
          {label}
        </ToggleGroupItem>
      ))}
      {showPeriodSelector ? (
        <Box as="li" className={toggleGroupItemCss}>
          {actions}
        </Box>
      ) : null}
    </ToggleGroup>
  )
}
